import Image from "next/image";
import type { z } from "zod/v4";
import type { GameSchema } from "@/lib/schema";
import {
  allBigSmall,
  alldoubelSingle,
  allSum,
  minutLettoDragTiger,
} from "@/utils/result";

export function MinuteLottoDraw({
  gameData,
}: {
  gameData: z.infer<typeof GameSchema>;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        {gameData.result.map((item, index) => (
          <Image
            key={`${index}-${item}`}
            src={`/ball/1063/${item}.png`}
            alt={item.toString()}
            width={32}
            height={32}
          />
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="rounded-sm border px-2 py-1">
          {minutLettoDragTiger(gameData.result)}
        </span>
        <span>总和</span>
        <span className="rounded-sm border px-2 py-1">
          {allSum(gameData.result)}
        </span>
        <span className="rounded-sm border px-2 py-1">
          {allBigSmall(gameData.result, 22)}
        </span>
        <span className="rounded-sm border px-2 py-1">
          {alldoubelSingle(gameData.result)}
        </span>
      </div>
    </div>
  );
}
